import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Flex, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";

function CardList(props) {
    const { items, ...rest } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const hoverBg = useColorModeValue("gray.100", "gray.600");

    return (
        <Flex wrap="wrap" gap="5" justify={{ base: "center", md: "flex-start" }} {...rest}>
            {items.map((item, index) => (
                <Card
                    key={item.route || index}
                    minW="300px"
                    cursor="pointer"
                    _hover={{ bg: hoverBg }}
                    onClick={() => {
                        if (item.onClick) {
                            item.onClick();
                        } else if (item.route) {
                            navigate(item.route);
                        }
                    }}
                >
                    <CardHeader>
                        <Flex align="center" gap={typeof item.icon === "function" ? "3" : "6"}>
                            {typeof item.icon === "function" ? (
                                <Icon as={item.icon} w="18px" h="18px" color="blue.500" />
                            ) : (
                                item.icon
                            )}
                            <Text fontSize="lg" fontWeight="bold">
                                {t(item.titleKey)}
                            </Text>
                        </Flex>
                    </CardHeader>
                    <CardBody>
                        <Text fontSize="sm" color="gray.500">
                            {t(item.descriptionKey)}
                        </Text>
                    </CardBody>
                </Card>
            ))}
        </Flex>
    );
}

export default CardList;